// TODO: remove deprecated feature flags
type PortalFeatureFlags = {
  /**
   * Whether a user has access to the import data features in the portal
   */
  importData: boolean
  /**
   * Whether a user can access the MFA settings
   */
  enableMfa: boolean
  /**
   * Whether MFA status is displayed in an organization's members table
   */
  displayMfaInMembersTable: boolean
  /**
   * Whether the user can access the organization activity page
   */
  organizationActivity: boolean
  /**
   * Whether the user can access the device dashboard feature
   */
  deviceDashboard: boolean
  /**
   * Whether the user can access the dql editor feature
   */
  dqlEditor: boolean
  /**
   * Whether the user can access the metrics tab
   */
  metrics: boolean
  /**
   * Whether the portal should audit app data interactions for the currenct user
   */
  auditAppDataInteraction: boolean
  /**
   * Whether the user can access the small peer metadata custom columns feature
   */
  peerMetadataColumns: boolean
  /**
   * Whether the user can access the app forge
   */
  appForge: boolean
  /**
   * Whether the user can issue writes to user-defined collections using the SDK
   */
  sdkWriteEnabled: boolean
}

/** A type that represents all of our feature flags. These are managed
 *  in LaunchDarkly, and can be found at:
 *  https://app.launchdarkly.com/default/{environment}/features
 *
 *  NOTE: flags can come back as undefined, so we need to use Partial
 **/
export type FeatureFlags = Partial<PortalFeatureFlags>

export { useFeatureFlags } from './useFeatureFlags'
